import {useLocalization} from '@shopify/hydrogen';

export const useISOCode = () => {
  const {
    country: {isoCode: countryCode},
    language: {isoCode: languageCode},
  } = useLocalization();

  const languageCodeForGRROQ = languageCode === 'ZH_TW' ? 'zh_TW' : 'en';
  const i18nCodeForGROQ = countryCode === 'TW' ? 'zh-tw' : 'zh-hk';

  return {
    languageCode: languageCodeForGRROQ,
    countryCode: i18nCodeForGROQ,
  };
};
